/**
 * Default Team Configs
 * สร้างอัตโนมัติเมื่อสร้างทีมใหม่
 * 
 * ตำแหน่งเก็บอุปกรณ์ = ตำแหน่งที่เก็บอุปกรณ์ (เช่น ตู้เก็บอุปกรณ์, ห้องเก็บอุปกรณ์)
 * แผนก = แผนกที่ใช้อุปกรณ์ (เช่น อายุรกรรม, ศัลยกรรม)
 * หอผู้ป่วย = หอผู้ป่วยที่ใช้อุปกรณ์ (เช่น หอผู้ป่วยอายุรกรรม, หอผู้ป่วยศัลยกรรม)
 */

export const DEFAULT_LOCATIONS = [
  'ตู้เก็บอุปกรณ์ 1',
  'ตู้เก็บอุปกรณ์ 2',
  'ตู้เก็บอุปกรณ์ 3',
  'ห้องเก็บอุปกรณ์',
  'ห้อง ICU',
  'ห้องผ่าตัด',
  'ห้องคลอด',
  'ห้องฉุกเฉิน'
];

export const DEFAULT_DEPARTMENTS = [
  'อายุรกรรม',
  'ศัลยกรรม',
  'สูติ-นรีเวช',
  'กุมารเวช',
  'ICU',
  'ห้องผ่าตัด',
  'ห้องคลอด',
  'ห้องฉุกเฉิน',
  'แผนกอื่นๆ'
];

export const DEFAULT_WARDS = [
  'หอผู้ป่วยอายุรกรรม',
  'หอผู้ป่วยศัลยกรรม',
  'หอผู้ป่วยสูติ-นรีเวช',
  'หอผู้ป่วยกุมารเวช',
  'หอผู้ป่วยวิกฤต (ICU)',
  'หอผู้ป่วยอื่นๆ'
];

/**
 * Default Beds
 * สร้างอัตโนมัติเมื่อสร้างทีมใหม่
 * แบ่งเป็น 4 หอผู้ป่วย (หอละ 5 เตียง)
 */
export const DEFAULT_BEDS = [
  // หอผู้ป่วยอายุรกรรม (5 เตียง)
  { bedNumber: '001', bedName: 'เตียง 1', ward: 'หอผู้ป่วยอายุรกรรม', department: 'อายุรกรรม' },
  { bedNumber: '002', bedName: 'เตียง 2', ward: 'หอผู้ป่วยอายุรกรรม', department: 'อายุรกรรม' },
  { bedNumber: '003', bedName: 'เตียง 3', ward: 'หอผู้ป่วยอายุรกรรม', department: 'อายุรกรรม' },
  { bedNumber: '004', bedName: 'เตียง 4', ward: 'หอผู้ป่วยอายุรกรรม', department: 'อายุรกรรม' },
  { bedNumber: '005', bedName: 'เตียง 5', ward: 'หอผู้ป่วยอายุรกรรม', department: 'อายุรกรรม' },
  
  // หอผู้ป่วยศัลยกรรม (5 เตียง)
  { bedNumber: '006', bedName: 'เตียง 6', ward: 'หอผู้ป่วยศัลยกรรม', department: 'ศัลยกรรม' },
  { bedNumber: '007', bedName: 'เตียง 7', ward: 'หอผู้ป่วยศัลยกรรม', department: 'ศัลยกรรม' },
  { bedNumber: '008', bedName: 'เตียง 8', ward: 'หอผู้ป่วยศัลยกรรม', department: 'ศัลยกรรม' },
  { bedNumber: '009', bedName: 'เตียง 9', ward: 'หอผู้ป่วยศัลยกรรม', department: 'ศัลยกรรม' },
  { bedNumber: '010', bedName: 'เตียง 10', ward: 'หอผู้ป่วยศัลยกรรม', department: 'ศัลยกรรม' },
  
  // หอผู้ป่วยสูติ-นรีเวช (5 เตียง)
  { bedNumber: '011', bedName: 'เตียง 11', ward: 'หอผู้ป่วยสูติ-นรีเวช', department: 'สูติ-นรีเวช' },
  { bedNumber: '012', bedName: 'เตียง 12', ward: 'หอผู้ป่วยสูติ-นรีเวช', department: 'สูติ-นรีเวช' },
  { bedNumber: '013', bedName: 'เตียง 13', ward: 'หอผู้ป่วยสูติ-นรีเวช', department: 'สูติ-นรีเวช' },
  { bedNumber: '014', bedName: 'เตียง 14', ward: 'หอผู้ป่วยสูติ-นรีเวช', department: 'สูติ-นรีเวช' },
  { bedNumber: '015', bedName: 'เตียง 15', ward: 'หอผู้ป่วยสูติ-นรีเวช', department: 'สูติ-นรีเวช' },
  
  // หอผู้ป่วยกุมารเวช (5 เตียง)
  { bedNumber: '016', bedName: 'เตียง 16', ward: 'หอผู้ป่วยกุมารเวช', department: 'กุมารเวช' },
  { bedNumber: '017', bedName: 'เตียง 17', ward: 'หอผู้ป่วยกุมารเวช', department: 'กุมารเวช' },
  { bedNumber: '018', bedName: 'เตียง 18', ward: 'หอผู้ป่วยกุมารเวช', department: 'กุมารเวช' },
  { bedNumber: '019', bedName: 'เตียง 19', ward: 'หอผู้ป่วยกุมารเวช', department: 'กุมารเวช' },
  { bedNumber: '020', bedName: 'เตียง 20', ward: 'หอผู้ป่วยกุมารเวช', department: 'กุมารเวช' }
];

/**
 * Pricing for adding custom configs
 */
export const TEAM_CONFIG_PRICING = {
  ADD_LOCATION: 10, // T Coins per location
  ADD_DEPARTMENT: 10, // T Coins per department
  ADD_WARD: 10, // T Coins per ward
  ADD_BED: 20, // T Coins per bed (if not Pro Plan)
};

